import { useOfferCardContext } from '../context/offerCardContext';

export const useUser = () => {
  const { user } = useOfferCardContext();

  return user;
};
